import PropTypes from 'prop-types';
import noop from '../../../../utils/noop';

export const DESKTOP_PLAN_PROPTYPES = {
  captions: PropTypes.shape({
    pricing: PropTypes.shape({
      first: PropTypes.string,
      second: PropTypes.string,
      period: PropTypes.string,
    }),
    name: PropTypes.string,
    description: PropTypes.string,
    cta: PropTypes.string,
    label: PropTypes.string,
  }),
  type: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  withExtraPrice: PropTypes.bool,
  highlighted: PropTypes.bool,
  disabled: PropTypes.bool,
  onPlanSelect: PropTypes.func,
};
